import { isActiveLikeStatus } from './studentStatus';

/** Green tier: attendance % must be strictly greater than this (70 → 71%+ is green). */
export const ATTENDANCE_PCT_GOOD_ABOVE = 70;
/** Orange/warning tier: pct in [ATTENDANCE_PCT_WARN_MIN, ATTENDANCE_PCT_GOOD_ABOVE] inclusive. */
export const ATTENDANCE_PCT_WARN_MIN = 50;

export function isAttendanceGoodStanding(pct) {
  return pct != null && !Number.isNaN(pct) && pct > ATTENDANCE_PCT_GOOD_ABOVE;
}

/**
 * Dedupe overlapping IDs across present/absent/leave arrays on one attendance record.
 * Priority: present > leave > absent (same id in multiple arrays counts once).
 */
export function dedupeAttendanceBuckets(data) {
  const presentSet = new Set(data?.presentStudents || []);
  const leaveSet = new Set(
    (data?.leaveStudents || []).filter((id) => !presentSet.has(id))
  );
  const absentSet = new Set(
    (data?.absentStudents || []).filter(
      (id) => !presentSet.has(id) && !leaveSet.has(id)
    )
  );
  return {
    presentSet,
    leaveSet,
    absentSet,
    presentCount: presentSet.size,
    absentCount: absentSet.size,
    leaveCount: leaveSet.size,
  };
}

/** Present + leave (excused), deduped — numerator for attendance % where leave counts as attended. */
export function attendedCountForSession(data) {
  const b = dedupeAttendanceBuckets(data);
  return b.presentCount + b.leaveCount;
}

/** Active + ActiveListener students for a campus (denominator for session attendance %). */
export function getCampusActiveStudentCount(students, campusCode) {
  if (!campusCode) return 0;
  return (students || []).filter(
    (s) => s.campusCode === campusCode && isActiveLikeStatus(s.status)
  ).length;
}

/**
 * Session attendance %: (present + leave) / total active students in campus.
 * Clamped to [0, 100] when campus total is known.
 */
export function sessionPresentPct(attendedCount, campusTotal) {
  if (!campusTotal || campusTotal <= 0) return null;
  const raw = ((attendedCount || 0) / campusTotal) * 100;
  return Math.min(100, Math.max(0, raw));
}
